<template>
  <v-autocomplete
    v-model="model"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    filled
    item-text="stall_name"
    item-value="id"
    label="Stallholder"
    placeholder="Start typing to Search"
    prepend-icon="mdi-account"
    return-object
    @change="change()"
    no-filter
    :disabled="disabled"
  >
    <stallholder-type-icon
      slot="prepend"
      v-if="selectedStallholderType"
      :type="selectedStallholderType"
    ></stallholder-type-icon>

    <template v-slot:item="{ item }">
      <template>
        <v-list-item-avatar
          :color="getStallholderColor(item.stallholder_type)"
          class="headline font-weight-light white--text"
        >
          {{ item.stallholder_type.charAt(0).toUpperCase() }}
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title v-html="item.stall_name"></v-list-item-title>
          <v-list-item-subtitle
            v-html="`${item.first_name} ${item.last_name}`"
          ></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import axios from "axios";
import StallholderTypeIcon from "../components/StallholderTypeIcon";

export default {
  props: {
    item: {
      type: Object,
      required: false
    },
    disabled: {
        type: Boolean,
        default: false
    }
  },
  data: () => ({
    descriptionLimit: 60,
    entries: [],
    isLoading: false,
    model: {},
    search: null,
    stallholderRequest: null
  }),
  components: {
    StallholderTypeIcon
  },
  watch: {
    search(val) {
      console.log("? " + val);
      if (val && val !== this.model.stall_name) {
        console.log(`val ${val} !== ${this.model.stall_name} `);
        console.log("NEED TO DO A SEARCH");

        if (this.stallholderRequest) this.stallholderRequest.cancel(); // cancel previous ajax if exists

        this.debounceStallholderSearch(val);
      } else if (!val) {
        console.log("NEED CLEARRRRR HERE");
        this.model = {};
        this.$emit("change", this.model);
      }
    },
  },
  methods: {
    change() {
      console.log("CGANGE;");
      this.$emit("change", this.model);
    },
    debounceStallholderSearch: _.debounce(function(e) {
      this.isLoading = true;
      console.log("innn searching");

      this.stallholderRequest = axios.CancelToken.source();

      if (this.search) {
        // incase already empty by the time this debounced function runs
        axios
          .get(
            `/wisdom-markets/v1/stallholders?s=${encodeURIComponent(
              this.search.trim()
            )}`,
            {
              headers: {
                Authorization: `Bearer ${this.$store.state.accessToken}`
              },
              cancelToken: this.stallholderRequest.token
            }
          )
          .then(res => {
            console.warn({ res });
            const { data } = res;
            this.entries = data;
            this.count = parseInt(res.headers["x-wp-total"]);
          })
          .catch(function(error) {
            if (axios.isCancel(error)) {
              console.log("Request cancelled", error.message);
            } else {
              console.log(error);
              console.log("why t hefick!!");
            }
          })
          .finally(() => {
            console.log("finnally");
            this.isLoading = false;
          });
      } else {
        console.log("search already empty");
        this.isLoading = false;
      }
    }, 700)
  },
  computed: {
    ...mapGetters(["getStallholderColor"]),

    items() {
      if (!this.entries) return [];

      return this.entries;
    },
    selectedStallholderType() {
      return this.model && this.model.stallholder_type
        ? this.model.stallholder_type
        : false;
    }
  },
  mounted() {
    // set default selected
    if (this.item && Object.keys(this.item).length > 0) {
      this.entries.push(this.item);
      this.model = this.item;
    }
  }
};
</script>
